import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppLayout from "@/components/layout/AppLayout";
import Projects from "@/pages/Projects";
import NewProject from "@/pages/NewProject";
import ProjectDashboard from "@/pages/ProjectDashboard";
import DocumentLibrary from "@/pages/DocumentLibrary";
import VitalisteAnalysis from "@/pages/VitalisteAnalysis";
import MacroAnalysis from "@/pages/MacroAnalysis";
import ClausesAnalysis from "@/pages/ClausesAnalysis";
import OddAnalysis from "@/pages/OddAnalysis";
import LegalAnalysis from "@/pages/LegalAnalysis";
import Simulator from "@/pages/Simulator";
import FreeQuery from "@/pages/FreeQuery";
import Reports from "@/pages/Reports";
import PresentationMode from "@/pages/PresentationMode";
import Infographics from "@/pages/Infographics";
import VitaePublica from "@/pages/VitaePublica";
import { Toaster } from "@/components/ui/sonner";

function LandingRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/app/projects" replace /> : <Landing />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingRoute />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<Navigate to="projects" replace />} />
              <Route path="projects" element={<Projects />} />
              <Route path="projects/new" element={<NewProject />} />
              <Route path="projects/:projectId" element={<ProjectDashboard />} />
              <Route path="projects/:projectId/documents" element={<DocumentLibrary />} />
              <Route path="projects/:projectId/analyses/macro" element={<MacroAnalysis />} />
              <Route path="projects/:projectId/analyses/vitaliste" element={<VitalisteAnalysis />} />
              <Route path="projects/:projectId/analyses/clauses" element={<ClausesAnalysis />} />
              <Route path="projects/:projectId/analyses/odd" element={<OddAnalysis />} />
              <Route path="projects/:projectId/analyses/legal" element={<LegalAnalysis />} />
              <Route path="projects/:projectId/simulator" element={<Simulator />} />
              <Route path="projects/:projectId/qa" element={<FreeQuery />} />
              <Route path="projects/:projectId/reports" element={<Reports />} />
              <Route path="projects/:projectId/infographics" element={<Infographics />} />
              <Route path="projects/:projectId/vitae" element={<VitaePublica />} />
              <Route path="projects/:projectId/present" element={<PresentationMode />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
